import React,{useState} from "react";

export default function JobDeletion({job,busy,onDelete}) {
  const [confirm,setConfirm]=useState(false);
  return <section className="banner-job-deletion"><h3>Delete job</h3><p>Remove this job from the working list. Its design and billing history will be preserved, and a manager can restore it.</p>
    {confirm ? <><p>Delete {job.clientName} - {job.team} ({job.year} {job.season})?</p><button disabled={busy} onClick={onDelete}>Confirm delete job</button><button disabled={busy} onClick={()=>setConfirm(false)}>Cancel delete</button></> : <button disabled={busy} onClick={()=>setConfirm(true)}>Delete job</button>}
  </section>;
}
